import * as React from "react"
import * as styles from '../styles/sale_description_section.module.css'

export function SaleDescriptionSection() {
    return (
        <section className={styles.sale_description}>
            <p className={styles.sale_description_text} >2025年夏 発売予定</p>
            <img className={styles.steam_logo} src="sp/steam.png" alt="steam_logo"/>
        </section>
    )
}